import { SectionsLayout } from './SectionElements';
import MyMap from '../Map';
import Footer from '../Footer';

import NavHeader from '../NavHeader';
import BannerAd from '../BannerAd';
import ScrollToTop from './ScrollToTop'
import Section from './Section';

const ArticleGrid = (props) => {
  
    console.log('ArticleGrid props', props);
    return (
      <>
      <ScrollToTop />
        <NavHeader /> 
        <SectionsLayout>
          {props && props.data && props.data.section_stories
            ? props.data.section_stories.map((section) => (
                <Section key={section.type} data={section} />
              ))
            : null}
        </SectionsLayout>
        
        </>
    );
  };
  
  export default ArticleGrid;